import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faEye, faUserPlus, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminDataTable.css';
import LeadDetailsModal from './LeadDetailsModal';

const LeadsTable = ({ leads, onEdit, onDelete, onLeadSelect, selectAll, onSelectAll, onCreateAccount }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  const truncateMessage = (message) => {
    if (!message) return '-';
    const words = message.split(' ');
    if (words.length > 5) {
      return words.slice(0, 5).join(' ') + '...';
    }
    return message;
  };

  const sortedLeads = [...leads].sort((a, b) => {
    if (a.is_priority && !b.is_priority) {
      return -1;
    }
    if (!a.is_priority && b.is_priority) {
      return 1;
    }
    return 0;
  });

  const handleViewClick = (lead) => {
    setSelectedLead(lead);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedLead(null);
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            <th>ID</th>
            <th>Created At</th>
            <th>Full Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Date</th>
            <th>Boat</th>
            <th>Message</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedLeads.map((lead) => (
            <tr key={lead.id} className={lead.is_priority ? 'is-priority-row' : ''}>
              <td>
                <input
                  type="checkbox"
                  checked={lead.isSelected || false}
                  onChange={(e) => onLeadSelect(lead.id, e.target.checked)}
                />
              </td>
              <td>#{lead.id}</td>
              <td>{lead.formatted_created_at}</td>
              <td>
                <span className="lead-name-with-icon">
                  {lead.lead_source === 'sales_popup' && (
                    <FontAwesomeIcon 
                      icon={faBullhorn} 
                      title="Sales Popup Lead" 
                      className="lead-source-icon"
                    />
                  )}
                  {lead.full_name}
                </span>
              </td>
              <td>{lead.email || '-'}</td>
              <td>{lead.phone}</td>
              <td>{lead.date || '-'}</td>
              <td>{lead.boat?.name || '-'}</td>
              <td>{truncateMessage(lead.message)}</td>
              <td>
                <div className="action-buttons">
                  <button className="button secondary" onClick={() => onDelete(lead)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                  <button className="button secondary" onClick={() => onEdit(lead)}>
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button className="button secondary" onClick={() => handleViewClick(lead)}>
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <LeadDetailsModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        lead={selectedLead}
      />
    </div>
  );
};

export default LeadsTable;